export default class BasketController {
    constructor() {
        window.getSessionData = () => {
            const iframe = document.querySelector('[data-basket-iframe]');
            if (iframe?.contentWindow) {
                iframe.contentWindow.postMessage('GetSession', '*');
            }
        };

        window.addEventListener('message', function (event) {
            if (event.origin === 'https://billetter.drkoncerthuset.dk') {
                const data = event.data;
                clearInterval(window.getSessionDataInterval);
                const basketAmountElem = document.querySelector('[data-basket-amount]');
                if (basketAmountElem) {
                    basketAmountElem.innerText = data?.order?.items?.length ?? '';
                }
            }
        });

        clearInterval(window.getSessionDataInterval);
        window.getSessionDataInterval = setInterval(() => {
            window.getSessionData();
        }, 1500);

        window.getSessionData();
    }
}
